<div class="dialog_container">
  <div class="header_row">
    <h4>{{title}}</h4>
    <mat-icon class="close" (click)="close()">close</mat-icon>
  </div>

  @if (vidChoice == 'howItWorks') {
  <div class="dialog__panel">
    @if (language == 'nl') {
    <div class="videoWrapper" style="padding: 56.25% 0 0 0; position: relative">
      <iframe
        src="https://player.vimeo.com/video/1162959628?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        title="Handyhand uitlegvideo"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        allowfullscreen
      ></iframe>
    </div>
    } @else if (language == 'da') {
    <div class="videoWrapper" style="padding: 56.25% 0 0 0; position: relative">
      <iframe
        src="https://player.vimeo.com/video/1143806020?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        [title]="'COMPONENTS.HOW_IT_WORKS_VIDEO.IFRAME_TITLE' | translate"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        allowfullscreen
      ></iframe>
    </div>
    } @else {
    <div class="videoWrapper" style="padding: 75% 0 0 0; position: relative">
      <iframe
        src="https://player.vimeo.com/video/1143801710?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        title="Handyhand Explainer English"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        allowfullscreen
      ></iframe>
    </div>
    }
  </div>
  } @if (vidChoice == 'cancelTask') {
  <div class="dialog__panel">
    <div class="videoWrapper">
      <iframe
        width="720"
        height="420"
        src="https://www.youtube.com/embed/-2QO5BnRwRg?autoplay=1"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
  } @if (vidChoice == 'payment') {
  <div class="dialog__panel">
    <div class="videoWrapper">
      <iframe
        width="720"
        height="420"
        src="https://www.youtube.com/embed/8H4oTEaugPg?autoplay=1"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
  }

  <div class="dialog__footer">
    <button class="footer__button cancel__button" (click)="close()">
      {{ 'PAGES.HOW_IT_WORKS.CLOSE' | translate }}
    </button>
  </div>
</div>
